const MAX_PARTICIPANTS = 10000;
const LARGE_N_WARNING_THRESHOLD = 2000;
const SEQUENCE_PREVIEW_LIMIT = 500;

const LARGE_N_WARNING_TEXT = `Large N warning: the full randomization list is preserved in exports, but the browser preview is limited to ${SEQUENCE_PREVIEW_LIMIT} rows for usability. Virtual scroll is recommended before showing more rows online.`;

module.exports = {
  LARGE_N_WARNING_TEXT,
  LARGE_N_WARNING_THRESHOLD,
  MAX_PARTICIPANTS,
  SEQUENCE_PREVIEW_LIMIT
};
